import { useState, type ReactNode } from 'react';
import {
  EditBlock,
  MAX_RECIPES_2_SERVINGS,
  MAX_RECIPES_4_SERVINGS,
  MIN_RECIPES_2_SERVINGS,
  MIN_RECIPES_4_SERVINGS,
} from '@hungryroot/plan';
import { type RecipeQuantityPricingOption } from '@hungryroot/rest';
import { EditRecipeNumberModal } from '../EditRecipeNumberModal/EditRecipeNumberModal';

export interface EditRecipeNumberBlockProps {
  testid?: string;
  className?: string;
  id?: string;
  heading: string;
  description: string;
  icon?: string | ReactNode;
  onClick: ({
    numLunch,
    numDinner,
  }: {
    numDinner: number;
    numLunch: number;
  }) => Promise<RecipeQuantityPricingOption | undefined>;
  onSubmit: ({
    numLunch,
    numDinner,
  }: {
    numLunch: number;
    numDinner: number;
  }) => void;
  servingSize: number;
  confirmButtonText: string;
  initialValues: {
    dinnerRecipes: number;
    lunchRecipes: number;
  };
  pricePerServing?: number;
  onCancel?: () => void;
  editDisabled?: boolean;
}

export const EditRecipeNumberBlock = ({
  testid,
  className,
  id,
  heading,
  description,
  icon,
  onClick,
  onSubmit,
  servingSize,
  confirmButtonText,
  initialValues,
  pricePerServing,
  onCancel,
  editDisabled,
}: EditRecipeNumberBlockProps) => {
  const [isEditRecipeNumberModalOpen, setIsEditRecipeNumberModalOpen] =
    useState(false);

  return (
    <>
      <EditBlock
        className={className}
        key={id}
        testid={testid}
        heading={heading}
        description={description}
        icon={icon}
        onClick={() => setIsEditRecipeNumberModalOpen(true)}
        editDisabled={editDisabled}
      />
      {isEditRecipeNumberModalOpen && (
        <EditRecipeNumberModal
          maxRecipes={
            servingSize === 2 ? MAX_RECIPES_2_SERVINGS : MAX_RECIPES_4_SERVINGS
          }
          minRecipes={
            servingSize === 2 ? MIN_RECIPES_2_SERVINGS : MIN_RECIPES_4_SERVINGS
          }
          confirmButtonText={confirmButtonText}
          initialValues={initialValues}
          pricePerServing={pricePerServing}
          isOpen={isEditRecipeNumberModalOpen}
          onCancel={() => {
            onCancel?.();
            setIsEditRecipeNumberModalOpen(false);
          }}
          onSubmit={(values) => {
            onSubmit({
              numLunch: values.lunchRecipes,
              numDinner: values.dinnerRecipes,
            });
            setIsEditRecipeNumberModalOpen(false);
          }}
          onClick={onClick}
        />
      )}
    </>
  );
};
